import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contactInformationTypeName'
})
export class ContactInformationTypeNamePipe implements PipeTransform {

  transform(value: number) {
    switch (value) {
      case 1:
        return 'E-Mail';
      case 2:
        return 'Telefon geschäftlich';
      case 3:
        return 'Mobil';
      case 4:
        return 'Fax';
    }
    return 'anderer Typ';
  }

}
